import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { LocationFilterEnum } from 'enums/global.enum';
import AppAccordion from 'shared/design-system/components/app-accordion';
import AppCard from 'shared/design-system/components/app-card';
import NoData from 'shared/design-system/components/no-data-box';
import LinksButton from 'shared/design-system/components/links-button';
import ModalAction from '../../project-list/project-detail/_components/modal-action';
import useFormPassiveCycle from 'shared/design-system/components/app-accordion/_hooks/useFormPassiveCycle';
import useGetAndMapOrders from './_hooks/useGetAndMapOrders';
import useGetPassiveCycleOptions from '../_hooks/useGetPassiveCycleOptions';
import FiltersOrders, { orderListFormData } from '../_components/filters-passive-cycle';
import useDeleteOrderById from './_hooks/useDeleteOrderById';
import AddOrderModal from './_components/add-order-modal';
import OrderListTable from './_components/order-list-table';
import ServerSidePaginator from 'shared/design-system/components/app-server-side-paginator';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { searchOrders } from '../_redux/actions';
import { filtersOrdersUsedSelector } from '../_redux/selectors';
import useGetAllUsers from 'shared/_hooks/useGetAllUsers';

const OrderList: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const filterUsed = useAppSelector(filtersOrdersUsedSelector);
  const { orders, paginatorData } = useGetAndMapOrders();
  const { mappedPassiveCycleOptions } = useGetPassiveCycleOptions('passive');
  const allUsers = useGetAllUsers();
  const [showAddOrderModal, setShowAddOrderModal] = useState<boolean>(false);
  const [showConfirmDeleteOrderModal, setShowConfirmDeleteOrderModal] = useState<boolean>(false);

  const [isOpen, setIsOpen] = useState<boolean>(true);
  const { onSubmit, onReset, chipsFormData, setChipsFormData, reset, filterParams } = useFormPassiveCycle(
    orderListFormData,
    setIsOpen
  );

  const [controlledDate, setControlledDate] = useState<any>(null);

  const handleReset = () => {
    onReset();
    controlledDate && setControlledDate([]);
    chipsFormData && setChipsFormData([]);
  };

  const { setIdToDelete, deleteOrderById } = useDeleteOrderById();

  const showModalDeleteOrder = (id: number) => {
    setIdToDelete(id);
    setShowConfirmDeleteOrderModal(true);
  };

  const changePage = (page: number) => {
    let filters = { ...filterUsed };
    debugger;
    if (filters.paging) {
      filters.paging = { ...filters.paging, page: page };
    }
    dispatch(searchOrders({ request: { contractOrderSearchDto: filters } }));
  };

  return (
    <>
      <div className="d-flex justify-content-between mt-3">
        <h4 className="text-gray-800 my-0">{t('Passive cycle orders')}</h4>
        <div>
          <LinksButton className="btn-sm btn-primary btn-teal px-4 ms-auto" onClick={() => setShowAddOrderModal(true)}>
            {t('+ Add order')}
          </LinksButton>
        </div>
      </div>

      <AppAccordion
        formData={orderListFormData}
        location={LocationFilterEnum.PASSIVE_CYCLE}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        chipsFormData={chipsFormData}
        setChipsFormData={setChipsFormData}
        reset={reset}
      >
        <FiltersOrders
          onSubmit={onSubmit}
          handleReset={handleReset}
          setControlledDate={setControlledDate}
          mappedPassiveCycleOptions={mappedPassiveCycleOptions}
          // onReset={onReset} control={control} register={register}
        />
      </AppAccordion>

      <AppCard title={t('All orders')} className="mt-3">
        {orders.length === 0 ? (
          <NoData msg={t('No orders found')} />
        ) : (
          <>
            <OrderListTable data={orders} showModalDeleteOrder={showModalDeleteOrder} />
          </>
        )}
        {orders?.length > 0 ? (
          <ServerSidePaginator
            currentPage={paginatorData?.page || 0}
            totalPages={paginatorData?.totalPages || 0}
            elementsToShow={orders.length}
            totalElements={paginatorData?.totalElements}
            onPageChange={(e) => changePage(e)}
          />
        ) : (
          ''
        )}
      </AppCard>
      <AddOrderModal
        show={showAddOrderModal}
        setShow={setShowAddOrderModal}
        mappedPassiveCycleOptions={mappedPassiveCycleOptions}
        allUsers={allUsers}
      />
      <ModalAction
        title={t('Delete order')}
        actionLabel={t('common.confirm')}
        cancelLabel={t('common.cancel')}
        action={() => {
          deleteOrderById();
        }}
        setShow={(value) => setShowConfirmDeleteOrderModal(value)}
        show={showConfirmDeleteOrderModal}
      >
        <span className="text-danger">
          <i className="fa-solid fa-triangle-exclamation" /> <b>{t('common.attention')}</b>{' '}
        </span>
        <div className="p-1">
          <p>
            {t('This action will delete the contract and all related associations. Are you sure you want to continue?')}
          </p>
        </div>
      </ModalAction>
    </>
  );
};

export default OrderList;
